/* eslint-disable */
import { useState, useMemo } from "react";
import { loadFromStorage } from "./Auth";

/* ═══════════════════════════════════════════════════════════
   FOOTY ANALYST — DASHBOARD
   100% real data from saved fixtures, squad, reports, analyses
   No fake numbers — if there's no data, says so honestly
═══════════════════════════════════════════════════════════ */

const DASH_CSS = `
.dash-wrap { font-family:'DM Sans',sans-serif; background:var(--cream); min-height:100%; }

/* NEXT MATCH BANNER */
.dash-next { background:var(--ink); border-bottom:3px solid var(--mustard); padding:0.85rem 1.5rem; display:flex; align-items:center; gap:1.2rem; flex-wrap:wrap; }
.dash-next-days { font-family:'Bebas Neue',sans-serif; font-size:2rem; letter-spacing:2px; color:var(--mustard); line-height:1; flex-shrink:0; }
.dash-next-lbl { font-size:0.5rem; font-weight:800; letter-spacing:2px; text-transform:uppercase; color:rgba(255,255,255,0.4); }
.dash-next-vs { font-family:'Bebas Neue',sans-serif; font-size:1.15rem; letter-spacing:2px; color:var(--white); }
.dash-next-meta { font-size:0.65rem; color:rgba(255,255,255,0.45); font-weight:300; margin-top:0.1rem; }
.dash-next-form { display:flex; gap:0.28rem; flex-shrink:0; }
.dash-form-dot { width:22px; height:22px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-family:'Bebas Neue',sans-serif; font-size:0.7rem; font-weight:800; }
.dash-form-dot.W { background:#16a34a; color:white; }
.dash-form-dot.D { background:var(--mustard); color:var(--ink); }
.dash-form-dot.L { background:var(--darkred); color:white; }
.dash-next-btn { padding:0.4rem 0.9rem; background:var(--mustard); color:var(--ink); border:none; font-family:'DM Sans',sans-serif; font-weight:800; font-size:0.65rem; letter-spacing:1.5px; text-transform:uppercase; cursor:pointer; margin-left:auto; flex-shrink:0; transition:all 0.2s; }
.dash-next-btn:hover { background:var(--mustard2); }

/* METRICS ROW */
.dash-metrics { display:grid; grid-template-columns:repeat(4,1fr); gap:1rem; margin-bottom:1.2rem; }
.dash-metric { background:var(--white); border:1.5px solid var(--rule); padding:1.1rem; position:relative; overflow:hidden; cursor:default; }
.dash-metric::after { content:''; position:absolute; bottom:0; left:0; right:0; height:3px; }
.dash-metric.teal::after { background:var(--teal); }
.dash-metric.mustard::after { background:var(--mustard); }
.dash-metric.darkred::after { background:var(--darkred); }
.dash-metric.green::after { background:#16a34a; }
.dash-metric-val { font-family:'Bebas Neue',sans-serif; font-size:2.5rem; letter-spacing:3px; color:var(--ink); line-height:1; }
.dash-metric-val.empty { color:var(--muted); font-size:1.8rem; }
.dash-metric-label { font-size:0.62rem; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:var(--muted); margin-top:0.2rem; }
.dash-metric-change { font-size:0.68rem; font-weight:700; margin-top:0.4rem; display:flex; align-items:center; gap:0.3rem; }
.dash-metric-change.up { color:#16a34a; }
.dash-metric-change.down { color:var(--darkred); }
.dash-metric-change.neutral { color:var(--muted); }

/* GRID */
.dash-grid { display:grid; grid-template-columns:2fr 1fr; gap:1rem; margin-bottom:1rem; }
.dash-grid-3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:1rem; margin-bottom:1rem; }
.dash-panel { background:var(--white); border:1.5px solid var(--rule); padding:1.1rem; }
.dash-panel-title { font-family:'DM Sans',sans-serif; font-size:0.72rem; font-weight:800; letter-spacing:2px; text-transform:uppercase; color:var(--ink2); margin-bottom:0.9rem; padding-bottom:0.6rem; border-bottom:1.5px solid var(--rule); display:flex; align-items:center; justify-content:space-between; }
.dash-chip { font-family:'DM Sans',sans-serif; font-size:0.52rem; font-weight:800; padding:0.12rem 0.42rem; background:var(--teal); color:var(--white); letter-spacing:1.5px; text-transform:uppercase; }

/* Bar chart */
.dash-bar-chart { display:flex; align-items:flex-end; gap:0.5rem; height:120px; padding-top:0.5rem; }
.dash-bar-col { flex:1; display:flex; flex-direction:column; align-items:center; gap:0.3rem; height:100%; }
.dash-bar-bg { flex:1; width:100%; background:var(--cream2); position:relative; border-radius:2px 2px 0 0; }
.dash-bar-fill { position:absolute; bottom:0; left:0; right:0; border-radius:2px 2px 0 0; transition:height 1s ease; }
.dash-bar-val { font-family:'Bebas Neue',sans-serif; font-size:0.72rem; letter-spacing:1px; color:var(--ink); }
.dash-bar-label { font-size:0.52rem; font-weight:700; color:var(--muted); letter-spacing:0.5px; text-align:center; white-space:nowrap; overflow:hidden; max-width:100%; }

/* Match row */
.dash-match-row { display:flex; align-items:center; gap:0.75rem; padding:0.55rem 0; border-bottom:1px solid var(--rule2); }
.dash-match-row:last-child { border-bottom:none; }
.dash-match-result { width:28px; height:28px; display:flex; align-items:center; justify-content:center; font-size:0.65rem; font-weight:800; flex-shrink:0; }
.dash-match-result.W { background:#16a34a; color:white; }
.dash-match-result.D { background:var(--mustard); color:var(--ink); }
.dash-match-result.L { background:var(--darkred); color:white; }
.dash-match-opp { font-size:0.82rem; font-weight:700; color:var(--ink); flex:1; }
.dash-match-score { font-family:'Bebas Neue',sans-serif; font-size:1rem; letter-spacing:1px; color:var(--ink); }
.dash-match-meta { font-size:0.6rem; color:var(--muted); font-style:italic; }
.dash-match-press { font-family:'Bebas Neue',sans-serif; font-size:0.85rem; letter-spacing:1px; margin-left:0.5rem; }

/* Squad top performers */
.dash-player-row { display:flex; align-items:center; gap:0.6rem; padding:0.5rem 0; border-bottom:1px solid var(--rule2); }
.dash-player-row:last-child { border-bottom:none; }
.dash-player-num { font-family:'Bebas Neue',sans-serif; font-size:1.1rem; letter-spacing:1px; color:var(--muted); width:22px; text-align:center; }
.dash-player-av { width:28px; height:28px; border-radius:50%; border:1.5px solid var(--ink); display:flex; align-items:center; justify-content:center; font-size:0.58rem; font-weight:800; color:white; flex-shrink:0; }
.dash-player-name { font-size:0.8rem; font-weight:700; color:var(--ink); flex:1; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.dash-player-stat { font-family:'Bebas Neue',sans-serif; font-size:1rem; letter-spacing:1px; text-align:right; }

/* Quick actions */
.dash-actions { display:grid; grid-template-columns:repeat(4,1fr); gap:0.75rem; margin-bottom:1rem; }
.dash-action { background:var(--white); border:1.5px solid var(--rule); border-left:3px solid var(--teal); padding:0.75rem 0.85rem; cursor:pointer; transition:all 0.2s; display:flex; align-items:center; gap:0.65rem; }
.dash-action:hover { border-color:var(--teal); border-left-color:var(--mustard); background:var(--teal4); }
.dash-action-icon { font-size:1.1rem; flex-shrink:0; }
.dash-action-label { font-family:'DM Sans',sans-serif; font-size:0.78rem; font-weight:800; color:var(--ink); }
.dash-action-sub { font-size:0.6rem; color:var(--muted); font-weight:300; }

/* Season bars */
.dash-season-stat { display:flex; align-items:center; gap:0.7rem; padding:0.45rem 0; border-bottom:1px solid var(--rule2); }
.dash-season-stat:last-child { border-bottom:none; }
.dash-season-label { font-size:0.68rem; font-weight:700; color:var(--muted); width:100px; flex-shrink:0; }
.dash-season-bar-bg { flex:1; height:8px; background:var(--cream2); border-radius:2px; position:relative; overflow:hidden; }
.dash-season-bar-fill { position:absolute; top:0; left:0; height:100%; border-radius:2px; transition:width 1s ease; }
.dash-season-val { font-family:'Bebas Neue',sans-serif; font-size:0.92rem; letter-spacing:1px; width:42px; text-align:right; }

/* Activity */
.dash-activity-item { display:flex; align-items:flex-start; gap:0.7rem; padding:0.55rem 0; border-bottom:1px solid var(--rule2); }
.dash-activity-item:last-child { border-bottom:none; }
.dash-activity-dot { width:10px; height:10px; border-radius:50%; flex-shrink:0; margin-top:0.3rem; }
.dash-activity-content { flex:1; }
.dash-activity-text { font-size:0.78rem; font-weight:500; color:var(--ink2); line-height:1.5; }
.dash-activity-time { font-size:0.62rem; color:var(--muted); font-style:italic; margin-top:0.1rem; }

/* Scout targets */
.dash-scout-row { display:flex; align-items:center; gap:0.65rem; padding:0.5rem 0; border-bottom:1px solid var(--rule2); }
.dash-scout-row:last-child { border-bottom:none; }
.dash-scout-name { font-size:0.8rem; font-weight:700; color:var(--ink); flex:1; }
.dash-scout-club { font-size:0.62rem; color:var(--muted); font-weight:300; }
.dash-interest { font-size:0.56rem; font-weight:800; padding:0.08rem 0.38rem; letter-spacing:1.5px; text-transform:uppercase; }
.dash-interest.sign { background:#dcfce7; color:#16a34a; border:1px solid #bbf7d0; }
.dash-interest.monitor { background:var(--mustard3); color:var(--mustard2); border:1px solid #f5dfa0; }
.dash-interest.trial { background:#dbeafe; color:#1d4ed8; border:1px solid #bfdbfe; }

/* Empty state */
.dash-empty-state { text-align:center; padding:2rem 1rem; }
.dash-empty-icon { font-size:2rem; margin-bottom:0.5rem; }
.dash-empty-text { font-size:0.75rem; color:var(--muted); font-style:italic; margin-bottom:0.75rem; line-height:1.6; }
.dash-empty-btn { padding:0.42rem 1rem; background:var(--teal); color:var(--white); border:none; font-family:'DM Sans',sans-serif; font-weight:800; font-size:0.65rem; letter-spacing:1.5px; text-transform:uppercase; cursor:pointer; }

/* Legend */
.dash-legend { display:flex; gap:0.9rem; margin-top:0.8rem; flex-wrap:wrap; }
.dash-legend-item { display:flex; align-items:center; gap:0.3rem; font-size:0.6rem; color:var(--muted); font-weight:600; }
.dash-legend-dot { width:10px; height:10px; border-radius:2px; flex-shrink:0; }

/* Prep checklist preview */
.dash-prep-item { display:flex; align-items:center; gap:0.55rem; padding:0.4rem 0; border-bottom:1px solid var(--rule2); font-size:0.75rem; }
.dash-prep-item:last-child { border-bottom:none; }
.dash-prep-tick { width:16px; height:16px; border-radius:2px; display:flex; align-items:center; justify-content:center; flex-shrink:0; font-size:0.62rem; }
.dash-prep-tick.done { background:var(--teal); color:white; }
.dash-prep-tick.todo { background:var(--cream2); border:1.5px solid var(--rule); }

@media(max-width:1100px) {
  .dash-metrics { grid-template-columns:repeat(2,1fr); }
  .dash-grid { grid-template-columns:1fr; }
  .dash-grid-3 { grid-template-columns:1fr 1fr; }
  .dash-actions { grid-template-columns:repeat(2,1fr); }
}
@media(max-width:600px) {
  .dash-metrics { grid-template-columns:repeat(2,1fr); gap:0.6rem; }
  .dash-grid-3 { grid-template-columns:1fr; }
  .dash-actions { grid-template-columns:repeat(2,1fr); gap:0.5rem; }
  .dash-action { padding:0.65rem 0.5rem; }
  .dash-action-icon { font-size:1.2rem; margin-bottom:0.25rem; }
  .dash-next { padding:0.7rem 0.85rem; gap:0.7rem; }
  .dash-next-days { font-size:1.6rem; }
}
`;

function posGroupColor(group) {
  if(group==="gk") return "#b45309";
  if(group==="def") return "var(--darkred)";
  if(group==="mid") return "var(--teal)";
  return "#16a34a";
}

function posGroup(pos) {
  if(pos==="GK") return "gk";
  if(["CB","RB","LB","WB","RWB","LWB"].includes(pos)) return "def";
  if(["CDM","CM","CAM","RM","LM"].includes(pos)) return "mid";
  return "att";
}

function ini(name) {
  return (name||"?").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);
}

function daysUntil(dateStr) {
  const today = new Date(); today.setHours(0,0,0,0);
  const d = new Date(dateStr); d.setHours(0,0,0,0);
  return Math.round((d-today)/(1000*60*60*24));
}

function fmtDate(dateStr) {
  return new Date(dateStr).toLocaleDateString("en-GB",{day:"numeric",month:"short"});
}

/* ══════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════ */
export default function Dashboard({ isScout=false, onNavigate=()=>{}, user=null }) {

  /* ── LOAD ALL REAL DATA ── */
  const squad    = useMemo(() => loadFromStorage("my_squad",[]) || [], []);
  const loadData = useMemo(() => loadFromStorage("load_management",{}) || {}, []);
  const injured  = useMemo(() => squad.filter(p=>loadData[p.id]?.status==="injured"||loadData[p.id]?.status==="suspended").length, [squad,loadData]);
  const reports  = useMemo(() => loadFromStorage("scout_reports",[]) || [], []);
  const fixtures = useMemo(() => loadFromStorage("fx_fixtures",[]) || [], []);
  const analyses = useMemo(() => loadFromStorage("va_analyses",[]) || [], []);
  const drills   = useMemo(() => loadFromStorage("session_drills",[]) || [], []);

  // Profile — read from user-keyed storage, fall back to pending onboarding data
  const profile = useMemo(() => {
    if (user?.id) {
      const stored = loadFromStorage(`profile_${user.id}`, null);
      if (stored) return stored;
    }
    // Pending onboarding (just signed up, email not confirmed yet)
    const pending = loadFromStorage('profile_pending', null);
    if (pending) return pending;
    // Absolute fallback — empty profile ready to fill
    return { name: user?.name || "", club: "", formation: "4-3-3", style: "possession" };
  }, [user?.id]);

  const clubName = profile.club || loadFromStorage("fx_club_name","My Club") || "My Club";

  /* ── DERIVED SEASON STATS ── */
  const played   = useMemo(() => fixtures.filter(f=>f.played).sort((a,b)=>new Date(b.date)-new Date(a.date)), [fixtures]);
  const upcoming = useMemo(() => fixtures.filter(f=>!f.played).sort((a,b)=>new Date(a.date)-new Date(b.date)), [fixtures]);
  const nextMatch = upcoming[0] || null;

  const wins   = played.filter(f=>f.goalsFor>f.goalsAgainst).length;
  const draws  = played.filter(f=>f.goalsFor===f.goalsAgainst).length;
  const losses = played.filter(f=>f.goalsFor<f.goalsAgainst).length;
  const gf     = played.reduce((s,f)=>s+f.goalsFor,0);
  const ga     = played.reduce((s,f)=>s+f.goalsAgainst,0);
  const pts    = wins*3+draws;
  const winRate= played.length>0?Math.round((wins/played.length)*100):0;

  // Average pressing efficiency from played fixtures and video analyses
  const pressMatches = played.filter(f=>f.pressEff>0);
  const avgPress = pressMatches.length>0
    ? Math.round(pressMatches.reduce((s,f)=>s+f.pressEff,0)/pressMatches.length)
    : analyses.length>0
      ? Math.round(analyses.reduce((s,a)=>s+(a.pressEfficiency||0),0)/analyses.length)
      : null;

  // Press trend — last 7 played matches with press data
  const pressTrendData = played.filter(f=>f.pressEff>0).slice(0,7).reverse();

  // Press trend direction
  const pressTrend = pressTrendData.length>=3
    ? pressTrendData[pressTrendData.length-1].pressEff > pressTrendData[0].pressEff ? "up"
      : pressTrendData[pressTrendData.length-1].pressEff < pressTrendData[0].pressEff ? "down" : "neutral"
    : "neutral";

  // Form — last 5 results
  const form = played.slice(0,5).map(f=>f.goalsFor>f.goalsAgainst?"W":f.goalsFor===f.goalsAgainst?"D":"L");

  // Scout targets
  const signTargets  = reports.filter(r=>r.interest==="sign");
  const monitorTargets = reports.filter(r=>r.interest==="monitor");

  // Top squad players by overall
  const topPlayers = [...squad].sort((a,b)=>(b.overall||0)-(a.overall||0)).slice(0,5);

  // Next match prep progress
  const nextPrep = nextMatch?.prep || {};
  const prepItems = ["dossier","tactics","training","setpieces","teamTalk"];
  const prepDone  = prepItems.filter(k=>nextPrep[k]).length;

  // Build real activity feed
  const activity = useMemo(() => {
    const items = [];
    // Recent results
    played.slice(0,2).forEach(f=>{
      const res = f.goalsFor>f.goalsAgainst?"W":f.goalsFor===f.goalsAgainst?"D":"L";
      items.push({
        text:`${res==="W"?"Won":"Drew"} ${f.goalsFor}–${f.goalsAgainst} vs ${f.opponent}${f.pressEff?` · Press ${f.pressEff}%`:""}`,
        time:fmtDate(f.date),
        color:res==="W"?"#16a34a":res==="D"?"var(--mustard)":"var(--darkred)",
      });
    });
    // Recent reports
    reports.slice(0,2).forEach(r=>{
      items.push({
        text:`Scout report filed — ${r.playerName} (${r.pos}) · ${r.club}`,
        time:r.created||"Recent",
        color:"var(--teal)",
      });
    });
    // Drills
    if(drills.length>0) items.push({
      text:`${drills.length} drill${drills.length!==1?"s":""} saved to training planner`,
      time:"This week",
      color:"var(--mustard)",
    });
    // Upcoming
    if(nextMatch) items.push({
      text:`Next: vs ${nextMatch.opponent} in ${Math.max(0,daysUntil(nextMatch.date))} days · ${nextMatch.venue==="home"?"Home":"Away"}`,
      time:fmtDate(nextMatch.date),
      color:"var(--darkred)",
    });
    return items.slice(0,6);
  }, [played,reports,drills,nextMatch]);

  /* ── QUICK ACTIONS ── */
  const ACTIONS = isScout ? [
    {icon:"🗄️",label:"Player Database",sub:"Search 500+ players",tab:"database"},
    {icon:"📋",label:"File Report",sub:"Scout a player",tab:"sreports"},
    {icon:"📊",label:"Upgrade Comparison",sub:"Compare targets",tab:"comparison"},
    {icon:"⭐",label:"Watchlist",sub:"Your targets",tab:"watchlist"},
  ] : [
    {icon:"📅",label:"Fixtures",sub:"Season schedule & prep",tab:"fixtures"},
    {icon:"✦",label:"AI Analyst",sub:"Ask Claude anything",tab:"ai"},
    {icon:"🎬",label:"Video Analysis",sub:"Upload footage",tab:"video"},
    {icon:"🎯",label:"Opposition Dossier",sub:"Pre-match prep",tab:"dossier"},
    {icon:"🏟️",label:"Squad Builder",sub:"Manage your squad",tab:"squadcoach"},
    {icon:"📋",label:"Scout Reports",sub:"File & review",tab:"sreports"},
    {icon:"🎨",label:"Tactics Board",sub:"Plan your system",tab:"tacticsboard"},
    {icon:"⚽",label:"Set Pieces",sub:"Design routines",tab:"setpiece"},
  ];

  // Inline setup checklist — tracks progress, auto-hides when all done
  const setupSteps = [
    { id:"squad",    icon:"🏟️", title:"Build Your Squad",   desc:"Add your players — powers AI, tactics board and load management.", action:"Build Squad →",   tab:"squadcoach", done: squad.length > 0 },
    { id:"fixtures", icon:"📅", title:"Add Fixtures",        desc:"Enter your season schedule to unlock match prep and results tracking.", action:"Add Fixtures →", tab:"fixtures",   done: fixtures.length > 0 },
    { id:"ai",       icon:"✦",  title:"Ask the AI Analyst",  desc:"Ask Claude anything about your squad, your system or your next opponent.", action:"Open AI →",    tab:"ai",         done: squad.length > 0 && analyses.length > 0 },
  ];
  const incompleteSteps = setupSteps.filter(s => !s.done);
  const setupComplete = incompleteSteps.length === 0;

  return (
    <>
      <style>{DASH_CSS}</style>
      <div className="dash-wrap">

        {/* MANAGER IDENTITY HEADER */}
        <div style={{background:"var(--ink)",borderBottom:"2px solid var(--rule)",padding:"0.75rem 1.5rem",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:"0.5rem"}}>
          <div style={{display:"flex",alignItems:"center",gap:"0.85rem"}}>
            <div style={{width:36,height:36,borderRadius:"50%",background:profile.kitColour||"var(--teal)",border:"2px solid rgba(255,255,255,0.2)",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Bebas Neue',sans-serif",fontSize:"0.85rem",color:"white",flexShrink:0}}>
              {(profile.name||user?.name||"?").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2)||"?"}
            </div>
            <div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"1rem",letterSpacing:"2px",color:"var(--white)",lineHeight:1}}>
                {profile.name || user?.name || "Manager"}
              </div>
              <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.62rem",color:"rgba(255,255,255,0.4)",fontWeight:400,marginTop:"0.1rem"}}>
                {[clubName!=="My Club"?clubName:null, profile.formation, profile.style?profile.style.charAt(0).toUpperCase()+profile.style.slice(1).replace('-',' '):null].filter(Boolean).join(" · ")||"Set up your profile →"}
              </div>
            </div>
          </div>
          {(!profile.club||!profile.formation)&&(
            <button onClick={()=>onNavigate("profile")}
              style={{padding:"0.28rem 0.75rem",background:"transparent",border:"1.5px solid rgba(255,255,255,0.2)",color:"rgba(255,255,255,0.5)",fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:"0.6rem",letterSpacing:"1.5px",textTransform:"uppercase",cursor:"pointer"}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor="var(--mustard)";e.currentTarget.style.color="var(--mustard)";}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor="rgba(255,255,255,0.2)";e.currentTarget.style.color="rgba(255,255,255,0.5)";}}>
              Complete Profile →
            </button>
          )}
        </div>

        {/* INLINE SETUP CHECKLIST — shows only until each step is done */}
        {!setupComplete && !isScout && (
          <div style={{background:"var(--cream2)",borderBottom:"2px solid var(--rule)",padding:"0.85rem 1.5rem"}}>
            <div style={{display:"flex",alignItems:"center",gap:"0.75rem",marginBottom:"0.55rem",flexWrap:"wrap"}}>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"0.82rem",letterSpacing:"2.5px",color:"var(--ink)"}}>Getting Started</div>
              <div style={{display:"flex",gap:"0.25rem"}}>
                {setupSteps.map((s,i)=>(
                  <div key={i} style={{width:32,height:4,borderRadius:2,background:s.done?"var(--teal)":"var(--rule)"}}/>
                ))}
              </div>
              <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.62rem",color:"var(--muted)",fontStyle:"italic"}}>
                {setupSteps.filter(s=>s.done).length}/{setupSteps.length} complete — auto-disappears when done
              </div>
            </div>
            <div style={{display:"flex",gap:"0.65rem",flexWrap:"wrap"}}>
              {incompleteSteps.map((step,i)=>(
                <div key={step.id} style={{background:"var(--white)",border:"1.5px solid var(--rule)",borderLeft:`3px solid ${i===0?"var(--teal)":i===1?"var(--mustard)":"var(--darkred)"}`,padding:"0.65rem 0.9rem",flex:"1 1 200px",minWidth:180,display:"flex",gap:"0.55rem",alignItems:"flex-start"}}>
                  <span style={{fontSize:"1rem",flexShrink:0,paddingTop:"0.05rem"}}>{step.icon}</span>
                  <div style={{flex:1}}>
                    <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"0.8rem",letterSpacing:"1.5px",color:"var(--ink)",marginBottom:"0.15rem"}}>{step.title}</div>
                    <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.63rem",color:"var(--muted)",fontWeight:300,lineHeight:1.55,marginBottom:"0.4rem"}}>{step.desc}</div>
                    <button onClick={()=>onNavigate(step.tab)} style={{padding:"0.28rem 0.7rem",background:i===0?"var(--teal)":"transparent",color:i===0?"var(--white)":"var(--teal)",border:`1.5px solid var(--teal)`,fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.58rem",letterSpacing:"1.5px",textTransform:"uppercase",cursor:"pointer"}}>
                      {step.action}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* NEXT MATCH BANNER */}
        {nextMatch && (
          <div className="dash-next">
            <div style={{textAlign:"center",flexShrink:0}}>
              <div className="dash-next-days">{Math.max(0,daysUntil(nextMatch.date))}</div>
              <div className="dash-next-lbl">days</div>
            </div>
            <div style={{width:1,height:40,background:"rgba(255,255,255,0.1)",flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}>
              <div className="dash-next-lbl">{nextMatch.competition} · Next Match</div>
              <div className="dash-next-vs">{clubName} vs {nextMatch.opponent}</div>
              <div className="dash-next-meta">
                {new Date(nextMatch.date).toLocaleDateString("en-GB",{weekday:"short",day:"numeric",month:"long"})} · {nextMatch.kickoff} · {nextMatch.venue==="home"?"Home":"Away"}
              </div>
            </div>
            {form.length>0&&(
              <div>
                <div className="dash-next-lbl" style={{textAlign:"center",marginBottom:"0.3rem"}}>Form</div>
                <div className="dash-next-form">
                  {form.map((r,i)=><div key={i} className={`dash-form-dot ${r}`}>{r}</div>)}
                </div>
              </div>
            )}
            <button className="dash-next-btn" onClick={()=>onNavigate("fixtures")}>
              Prepare →
            </button>
          </div>
        )}

        <div style={{padding:"1.2rem 1.5rem"}}>

          {/* INJURY ALERT */}
        {injured>0&&(
          <div style={{background:"var(--darkred3)",border:"1.5px solid var(--darkred)",borderLeft:"4px solid var(--darkred)",padding:"0.72rem 1rem",marginBottom:"1rem",display:"flex",alignItems:"center",justifyContent:"space-between",gap:"0.75rem",flexWrap:"wrap"}}>
            <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.78rem",color:"var(--darkred)",fontWeight:600}}>
              🏥 {injured} player{injured!==1?"s":""} currently unavailable — {squad.filter(p=>loadData[p.id]?.status==="injured"||loadData[p.id]?.status==="suspended").map(p=>p.name.split(" ")[0]).join(", ")}
            </div>
            <button onClick={()=>onNavigate("load")} style={{padding:"0.3rem 0.75rem",background:"var(--darkred)",color:"var(--white)",border:"none",fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.62rem",letterSpacing:"1.5px",textTransform:"uppercase",cursor:"pointer",flexShrink:0}}>
              Manage →
            </button>
          </div>
        )}

        {/* METRICS */}
          <div className="dash-metrics">
            <div className="dash-metric teal">
              {played.length>0?(
                <>
                  <div className="dash-metric-val">{pts}</div>
                  <div className="dash-metric-label">Points This Season</div>
                  <div className={`dash-metric-change ${winRate>=50?"up":winRate>=33?"neutral":"down"}`}>
                    {wins}W {draws}D {losses}L · {winRate}% win rate
                  </div>
                </>
              ):(
                <>
                  <div className="dash-metric-val empty">—</div>
                  <div className="dash-metric-label">Points This Season</div>
                  <div className="dash-metric-change neutral" style={{cursor:"pointer"}} onClick={()=>onNavigate("fixtures")}>
                    → Log your first result
                  </div>
                </>
              )}
            </div>

            <div className="dash-metric green">
              {avgPress!==null?(
                <>
                  <div className="dash-metric-val" style={{color:avgPress>=75?"#16a34a":avgPress>=65?"var(--teal)":avgPress>=55?"var(--mustard)":"var(--darkred)"}}>
                    {avgPress}%
                  </div>
                  <div className="dash-metric-label">Avg Pressing Efficiency</div>
                  <div className={`dash-metric-change ${pressTrend==="up"?"up":pressTrend==="down"?"down":"neutral"}`}>
                    {pressTrend==="up"?"▲ Improving":pressTrend==="down"?"▼ Declining":"→ Stable"} · {pressMatches.length} matches
                  </div>
                </>
              ):(
                <>
                  <div className="dash-metric-val empty">—</div>
                  <div className="dash-metric-label">Avg Pressing Efficiency</div>
                  <div className="dash-metric-change neutral" style={{cursor:"pointer"}} onClick={()=>onNavigate("video")}>
                    → Run a video analysis
                  </div>
                </>
              )}
            </div>

            <div className="dash-metric mustard">
              <div className={`dash-metric-val ${squad.length===0?"empty":""}`}>{squad.length||"—"}</div>
              <div className="dash-metric-label">Players in Squad</div>
              <div className={`dash-metric-change ${squad.length>0?"up":"neutral"}`} style={squad.length===0?{cursor:"pointer"}:{}} onClick={()=>squad.length===0&&onNavigate("squadcoach")}>
                {squad.length>0
                  ? `${squad.filter(p=>p.group==="att").length} att · ${squad.filter(p=>p.group==="mid").length} mid · ${squad.filter(p=>p.group==="def").length} def · ${squad.filter(p=>p.group==="gk").length} gk`
                  : "→ Build your squad"}
              </div>
            </div>

            <div className="dash-metric darkred">
              <div className={`dash-metric-val ${reports.length===0?"empty":""}`}>
                {reports.length>0?signTargets.length:"—"}
              </div>
              <div className="dash-metric-label">Sign Now Targets</div>
              <div className={`dash-metric-change ${signTargets.length>0?"up":"neutral"}`} style={reports.length===0?{cursor:"pointer"}:{}} onClick={()=>reports.length===0&&onNavigate("sreports")}>
                {reports.length>0
                  ? `${monitorTargets.length} monitoring · ${reports.length} total reports`
                  : "→ File your first report"}
              </div>
            </div>
          </div>

          {/* PRESSING TREND + RECENT RESULTS */}
          <div className="dash-grid">
            <div className="dash-panel">
              <div className="dash-panel-title">
                Pressing Efficiency
                <span className="dash-chip">{pressTrendData.length>0?`${pressTrendData.length} matches`:"No data yet"}</span>
              </div>
              {pressTrendData.length===0?(
                <div className="dash-empty-state">
                  <div className="dash-empty-icon">📈</div>
                  <div className="dash-empty-text">
                    Your pressing efficiency trend will appear here once you log match results with press data.<br/>
                    Go to Fixtures → log a result and add a pressing % figure.
                  </div>
                  <button className="dash-empty-btn" onClick={()=>onNavigate("fixtures")}>Go to Fixtures →</button>
                </div>
              ):(
                <>
                  <div className="dash-bar-chart">
                    {pressTrendData.map((m,i)=>(
                      <div key={i} className="dash-bar-col">
                        <div className="dash-bar-val">{m.pressEff}</div>
                        <div className="dash-bar-bg">
                          <div className="dash-bar-fill" style={{
                            height:`${m.pressEff}%`,
                            background:m.pressEff>=75?"#16a34a":m.pressEff>=65?"var(--teal)":m.pressEff>=55?"var(--mustard)":"var(--darkred)",
                          }}/>
                        </div>
                        <div className="dash-bar-label">{fmtDate(m.date)}</div>
                      </div>
                    ))}
                  </div>
                  <div className="dash-legend">
                    {[{c:"#16a34a",l:"75%+ Strong"},{c:"var(--teal)",l:"65-74% Good"},{c:"var(--mustard)",l:"55-64% Developing"},{c:"var(--darkred)",l:"<55% Concern"}].map((l,i)=>(
                      <div key={i} className="dash-legend-item">
                        <div className="dash-legend-dot" style={{background:l.c}}/>
                        {l.l}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>

            <div className="dash-panel">
              <div className="dash-panel-title">
                Recent Results
                <span className="dash-chip">{played.length} played</span>
              </div>
              {played.length===0?(
                <div className="dash-empty-state">
                  <div className="dash-empty-icon">⚽</div>
                  <div className="dash-empty-text">No results logged yet. Add fixtures and log your results.</div>
                  <button className="dash-empty-btn" onClick={()=>onNavigate("fixtures")}>Add Fixtures →</button>
                </div>
              ):(
                played.slice(0,6).map((m,i)=>{
                  const res = m.goalsFor>m.goalsAgainst?"W":m.goalsFor===m.goalsAgainst?"D":"L";
                  return(
                    <div key={i} className="dash-match-row">
                      <span className={`dash-match-result ${res}`}>{res}</span>
                      <div style={{flex:1,minWidth:0}}>
                        <div className="dash-match-opp">{m.opponent}</div>
                        <div className="dash-match-meta">{fmtDate(m.date)} · {m.venue==="home"?"H":"A"}{m.possession?` · ${m.possession}% poss`:""}</div>
                      </div>
                      <div className="dash-match-score">{m.goalsFor}–{m.goalsAgainst}</div>
                      {m.pressEff>0&&<div className="dash-match-press" style={{color:m.pressEff>=75?"#16a34a":m.pressEff>=65?"var(--teal)":"var(--mustard)"}}>{m.pressEff}%</div>}
                    </div>
                  );
                })
              )}
            </div>
          </div>

          {/* QUICK ACTIONS */}
          <div className="dash-actions">
            {ACTIONS.map((a,i)=>(
              <div key={i} className="dash-action" onClick={()=>onNavigate(a.tab)}>
                <div className="dash-action-icon">{a.icon}</div>
                <div>
                  <div className="dash-action-label">{a.label}</div>
                  <div className="dash-action-sub">{a.sub}</div>
                </div>
              </div>
            ))}
          </div>

          {/* BOTTOM ROW */}
          <div className="dash-grid-3">

            {/* Top performers from real squad */}
            <div className="dash-panel">
              <div className="dash-panel-title">
                Squad Overview
                <span className="dash-chip">{squad.length} players</span>
              </div>
              {squad.length===0?(
                <div className="dash-empty-state">
                  <div className="dash-empty-icon">🏟️</div>
                  <div className="dash-empty-text">Build your squad to see your top performers here.</div>
                  <button className="dash-empty-btn" onClick={()=>onNavigate("squadcoach")}>Build Squad →</button>
                </div>
              ):(
                topPlayers.map((p,i)=>(
                  <div key={p.id||i} className="dash-player-row">
                    <div className="dash-player-num">{i+1}</div>
                    <div className="dash-player-av" style={{background:posGroupColor(p.group||posGroup(p.pos))}}>{ini(p.name)}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div className="dash-player-name">{p.name}</div>
                      <span className={`sp-pos-badge ${p.group||posGroup(p.pos)}`} style={{fontSize:"0.52rem",padding:"0.06rem 0.3rem"}}>{p.pos}</span>
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <div className="dash-player-stat" style={{color:"var(--teal)"}}>{p.overall||70}</div>
                      <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.52rem",color:"var(--muted)",letterSpacing:"1px",textTransform:"uppercase",fontWeight:700}}>OVR</div>
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Season summary from real data */}
            <div className="dash-panel">
              <div className="dash-panel-title">Season Summary <span className="dash-chip">{(()=>{const y=new Date().getFullYear();const m=new Date().getMonth();return m>=7?`${y}/${String(y+1).slice(2)}`:`${y-1}/${String(y).slice(2)}`;})()}</span></div>
              {played.length===0?(
                <div className="dash-empty-state">
                  <div className="dash-empty-icon">📊</div>
                  <div className="dash-empty-text">Season stats will build here as you log match results.</div>
                  <button className="dash-empty-btn" onClick={()=>onNavigate("fixtures")}>Add Fixtures →</button>
                </div>
              ):(
                [
                  {label:"Win rate",    val:`${winRate}%`,        pct:winRate,                                  color:"#16a34a"},
                  {label:"Press eff.",  val:avgPress?`${avgPress}%`:"—",  pct:avgPress||0,                    color:"var(--teal)"},
                  {label:"Goals scored",val:String(gf),           pct:Math.min(100,gf*4),                       color:"var(--mustard)"},
                  {label:"Goals conceded",val:String(ga),         pct:Math.min(100,ga*4),                       color:"var(--darkred)"},
                  {label:"Clean sheets",val:String(played.filter(f=>f.goalsAgainst===0).length),
                                        pct:Math.round(played.filter(f=>f.goalsAgainst===0).length/played.length*100), color:"#16a34a"},
                  {label:"Possession", val:played.filter(f=>f.possession>0).length>0
                    ?`${Math.round(played.filter(f=>f.possession>0).reduce((s,f)=>s+f.possession,0)/played.filter(f=>f.possession>0).length)}%`:"—",
                    pct:played.filter(f=>f.possession>0).length>0
                    ?Math.round(played.filter(f=>f.possession>0).reduce((s,f)=>s+f.possession,0)/played.filter(f=>f.possession>0).length):0,
                    color:"var(--teal)"},
                ].map((s,i)=>(
                  <div key={i} className="dash-season-stat">
                    <div className="dash-season-label">{s.label}</div>
                    <div className="dash-season-bar-bg">
                      <div className="dash-season-bar-fill" style={{width:`${s.pct}%`,background:s.color,opacity:0.8}}/>
                    </div>
                    <div className="dash-season-val" style={{color:s.color}}>{s.val}</div>
                  </div>
                ))
              )}
            </div>

            {/* Real activity / scout targets */}
            <div className="dash-panel">
              <div className="dash-panel-title">
                {reports.length>0?"Scout Targets":"Recent Activity"}
                <span className="dash-chip">{reports.length>0?`${reports.length} reports`:"Live"}</span>
              </div>
              {reports.length>0?(
                <>
                  {reports.filter(r=>["sign","monitor","trial"].includes(r.interest)).slice(0,5).map((r,i)=>(
                    <div key={i} className="dash-scout-row">
                      <div style={{flex:1,minWidth:0}}>
                        <div className="dash-scout-name">{r.playerName}</div>
                        <div className="dash-scout-club">{r.pos} · {r.club}</div>
                      </div>
                      <span className={`dash-interest ${r.interest}`}>
                        {r.interest==="sign"?"Sign":r.interest==="monitor"?"Monitor":"Trial"}
                      </span>
                    </div>
                  ))}
                  {reports.filter(r=>["sign","monitor","trial"].includes(r.interest)).length===0&&(
                    <div className="dash-empty-state">
                      <div className="dash-empty-text">No active targets yet. File reports and mark players as Sign, Monitor or Trial.</div>
                    </div>
                  )}
                </>
              ):(
                activity.length===0?(
                  <div className="dash-empty-state">
                    <div className="dash-empty-icon">📡</div>
                    <div className="dash-empty-text">Your activity will appear here as you use the platform — match results, reports filed, drills added.</div>
                  </div>
                ):(
                  activity.map((a,i)=>(
                    <div key={i} className="dash-activity-item">
                      <div className="dash-activity-dot" style={{background:a.color}}/>
                      <div className="dash-activity-content">
                        <div className="dash-activity-text">{a.text}</div>
                        <div className="dash-activity-time">{a.time}</div>
                      </div>
                    </div>
                  ))
                )
              )}
            </div>

          </div>

          {/* NEXT MATCH PREP if applicable */}
          {nextMatch&&(
            <div className="dash-panel" style={{marginBottom:"1rem",borderTop:"3px solid var(--teal)"}}>
              <div className="dash-panel-title">
                Match Prep — vs {nextMatch.opponent}
                <span className="dash-chip">{prepDone}/5 Complete</span>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:"0.5rem"}}>
                {["Opposition Dossier","Tactical Plan","Training Session","Set Pieces","Team Talk"].map((label,i)=>{
                  const keys = ["dossier","tactics","training","setpieces","teamTalk"];
                  const done = nextPrep[keys[i]];
                  return(
                    <div key={i} className="dash-prep-item" style={{flexDirection:"column",alignItems:"center",textAlign:"center",border:"1.5px solid var(--rule)",padding:"0.65rem 0.4rem",cursor:"pointer",background:done?"var(--teal4)":"var(--white)",transition:"all 0.15s"}}
                      onClick={()=>onNavigate("fixtures")}>
                      <div className={`dash-prep-tick ${done?"done":"todo"}`} style={{width:20,height:20,marginBottom:"0.35rem"}}>
                        {done?"✓":""}
                      </div>
                      <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.62rem",fontWeight:700,color:done?"var(--teal)":"var(--ink)",lineHeight:1.35}}>{label}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

        </div>
      </div>
    </>
  );
}
